export enum Player {
    red,
    orange,
    green,
    blue
}
export enum PlayerEntity {
    empty,
    localPlayer,
    android
}
